import React from "react";
import {
  Box,
  ClockIcon,
  EmailIcon,
  Link,
  OpenInNewTabIcon,
  PhoneIcon,
  Typography
} from "@dealer-center/core-components";
import {
  CONTAINER_STYLES,
  LINK_STYLES,
  TYPOGRAPHY_STYLES
} from "../styleConstants";

// Map icon keys to Interstate icon components
const ICON_MAP: Record<string, React.ComponentType<any>> = {
  phone: PhoneIcon,
  email: EmailIcon,
  openInNewTab: OpenInNewTabIcon,
  clock: ClockIcon
};

interface ContactDetailItemProps {
  iconKey: string;
  iconColor: string;
  iconTitle: string;
  value: string;
  label?: string;
  href?: string;
  isExternal?: boolean;
  textColor?: string;
  textWeight?: number;
  prefix?: string;
  suffix?: string;
}

export const ContactDetailItem: React.FC<ContactDetailItemProps> = ({
  iconKey,
  iconColor,
  iconTitle,
  value,
  label,
  href,
  isExternal = false,
  textColor = "#666",
  textWeight = 400,
  prefix,
  suffix
}) => {
  const Icon = ICON_MAP[iconKey];

  if (!Icon) {
    return null;
  }

  return (
    <Box sx={{ ...CONTAINER_STYLES.flexRowCenterGap, minWidth: 0 }}>
      <Icon
        style={{ fontSize: 14, color: iconColor, flexShrink: 0 }}
        title={iconTitle}
      />
      {href ? (
        <Link
          href={href}
          rel={isExternal ? "noopener noreferrer" : undefined}
          sx={{
            ...LINK_STYLES.standard,
            color: textColor,
            "&&": { color: textColor },
            wordBreak: "break-word",
            minWidth: 0
          }}
          target={isExternal ? "_blank" : undefined}
        >
          {label || value}
        </Link>
      ) : (
        <Typography
          sx={{
            ...TYPOGRAPHY_STYLES.body,
            color: textColor,
            fontWeight: textWeight,
            wordBreak: "break-word",
            minWidth: 0
          }}
          variant="body-md"
        >
          {prefix && `${prefix} `}
          {label && `${label}: `}
          {value}
          {suffix && ` (${suffix})`}
        </Typography>
      )}
    </Box>
  );
};
